import React from 'react';
import { Support as SupportPage } from '@homeexchange/support';
import { SUPPORT_PAGES } from './constants';
import { withCurrency } from '../currency';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getDynamicUrl } from '../../middleware/lokaliseUrlMiddleware';
import { selectSession } from '../../selectors/session';
var Support = function (props) {
    var session = props.session, localeDescription = props.localeDescription, currency = props.currency;
    var isAnonymous = !session || session.status === 'anonymous';
    var slug = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var pageToDisplay = SUPPORT_PAGES.find(function (page) { return page.slugs.includes(slug); });
    return (React.createElement("div", { style: {
            marginTop: isAnonymous && pageToDisplay.page === 'regular-contact' ? '80px' : '0px'
        } },
        React.createElement(SupportPage, { page: pageToDisplay.page, config: {
                apiUrl: getDynamicUrl(process.env.URL_BFF),
                assetsUrl: process.env.URL_MIGRATION_ASSETS,
                locale: localeDescription,
                currency: currency,
                session: session
            } })));
};
var mapStateToProps = function (state) { return ({
    session: selectSession(state),
    localeDescription: state.localeDescription,
    currency: state.currency
}); };
export default compose(connect(mapStateToProps), withCurrency)(Support);
